<template>
    <div :class="['animated', 'fadeIn', 'container', isMobile ? 'my-2' : 'my-4']">
        <h4 v-if="isMobile">{{ item.name }}</h4>
        <h1 v-else>{{ item.name }}</h1>
        <div class="text-muted">
            <i class="fa fa-calendar mr-1" /> {{ item.date | formatDateTime }}
            <span class="mx-2">|</span> <i class="fa fa-eye mr-1" /> {{ count }} Lượt xem
        </div>
        <div class="quillWrapper" v-if="item.sapo">
            <div class="ql-snow">
                <div id="html-content" class="ql-editor" style="display: flow-root; padding: 12px 0px"
                    v-html="item.sapo" />
            </div>
        </div>
        <div class="quillWrapper">
            <div class="ql-snow">
                <div id="html-content" class="ql-editor content" style="display: flow-root; padding: 12px 0px"
                    v-html="item.content" />
            </div>
        </div>
        <div class="mt-2" v-if="item.files && item.files.length">
            Tệp đính kèm
            <div v-for="file in item.files">
                <a @click="openFile(file)" class="text-dark cursor-pointer">
                    <i :class="`fa ${file.includes('.pdf')
                        ? 'fa-file-pdf-o'
                        : file.includes('.doc')
                            ? 'fa-file-word-o'
                            : 'fa-picture-o'
                        } mr-2`" />{{ displayFile(file) }}
                </a>
            </div>
        </div>
        <div class="mt-1 text-right" v-if="item.author">
            <i><b>{{ item.author }}</b></i>
        </div>
        <SectionTitle :title="'Các tin liên quan'" class="mt-4" />
        <h5>Tin hoạt động:</h5>
        <div v-for="news in listNormalNewsDisplay" :key="news.id">
            <a :href="`/news/${news.id}`" target="_blank">{{ news.name }}</a> -
            <i class="text-muted">{{ $moment(news.date).format('DD/MM/YYYY HH:mm') }}</i>
        </div>
        <h5 class="mt-2">Tin cảnh báo:</h5>
        <div v-for="news in listWarningNewsDisplay" :key="news.id">
            <a :href="`/news/${news.id}`" target="_blank">{{ news.name }}</a> -
            <i class="text-muted">{{ $moment(news.date).format('DD/MM/YYYY HH:mm') }}</i>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import API_CONFIG from '@/api-config';
import SectionTitle from '@/components/SectionTitle';
export default {
    components: {
        SectionTitle
    },
    data() {
        return {
            viewCount: 0
        };
    },
    computed: {
        ...mapState({
            item: (state) => state.news.item,
            items: (state) => state.news.items,
            isMobile: (state) => state.page.isMobile
        }),
        count() {
            return this.viewCount;
        },
        listWarningNewsDisplay() {
            let listData = this.items.filter(
                (item) => item.status == 'PUBLISH' && item.type == 'WARNING'
            );
            return listData.sort((a, b) => this.compareDate(a, b)).slice(0, 5);
        },
        listNormalNewsDisplay() {
            let listData = this.items.filter(
                (item) => item.status == 'PUBLISH' && item.type == 'NORMAL'
            );
            return listData.sort((a, b) => this.compareDate(a, b)).slice(0, 5);
        }
    },
    created() {
        if (!this.items.length) this.getList();
        window.scrollTo(0, 0);
    },
    async mounted() {
        const newsId = this.$route.params.id;
        if (newsId) {
            try {
                await this.getInfo({ id: newsId });
                await this.addViewByNews({ newsId: parseInt(newsId) });
                setTimeout(async () => {
                    const res = await this.getViewByNews({ newsId: newsId });
                    this.viewCount = res.count;
                }, 500);
            } catch (error) {
                this.$router.push('/home');
                this.$toaster.error('Không tìm thấy bài viết');
            }
        }
    },
    methods: {
        ...mapActions({
            getInfo: 'news/getInfo',
            getList: 'news/getList',
            addViewByNews: 'news/addViewByNews',
            getViewByNews: 'news/getViewByNews'
        }),
        openFile(link) {
            const newTab = `${API_CONFIG.URL_GET_FILE}${link}`;
            window.open(newTab, '_blank');
        },
        displayFile(file) {
            const arr = file.split('_');
            return arr[arr.length - 1];
        },
        compareDate(a, b) {
            if (this.$moment(a.date).isAfter(this.$moment(b.date))) return -1;
            if (this.$moment(a.date).isBefore(this.$moment(b.date))) return 1;
            return 0;
        }
    }
};
</script>
<style lang="scss">
.content>p {
    font-size: 13pt;
}
</style>
